import "./datadog.client";
import { Protect, useAuth } from "@clerk/remix";
import {
  Link,
  NavLink,
  Outlet,
  RemixBrowser,
  useMatches,
  useNavigate,
  useSearchParams,
} from "@remix-run/react";
import { RouterContext, SpinnerContext } from "@repo/ui";
import riveWasmUrl from "@rive-app/canvas/rive.wasm";
import { RuntimeLoader } from "@rive-app/react-canvas";
import countries from "i18n-iso-countries";
import countriesEn from "i18n-iso-countries/langs/en.json";
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import spinnerUrl from "./assets/animations/primary-spinner.riv";

RuntimeLoader.setWasmUrl(riveWasmUrl);

countries.registerLocale(countriesEn);

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RouterContext.Provider
        value={{
          Link,
          NavLink,
          Outlet,
          Protect,
          useSearchParams,
          useNavigate,
          useMatches,
          useAuth,
          getIsAdminRoute: () => {
            return !!useMatches().find((match) => match.id === "routes/admin");
          },
        }}
      >
        <SpinnerContext.Provider value={{ spinnerUrl }}>
          <RemixBrowser />
        </SpinnerContext.Provider>
      </RouterContext.Provider>
    </StrictMode>,
  );
});
